import {dayNamesArray, type IHoursOption} from "@pg-design/calendar-module";

import {IOfficesHoursData} from "../types/IOfficesHoursData";

export const getHoursOptionsFromOfficesData = (officesHoursData?: IOfficesHoursData) => {
    if (!officesHoursData) {
        return undefined;
    }
    const validHoursKeys = Object.keys(officesHoursData).filter((key) => key.includes("open_hours"));

    return validHoursKeys.reduce((acc, key) => {
        const keySplit = key.split("_");
        const dayNumber = +keySplit[keySplit.length - 1];
        // @ts-ignore
        const range = officesHoursData[key];
        if (range) {
            acc.push({
                dayName: dayNamesArray[dayNumber <= 6 ? dayNumber : 0],
                range
            });
        }

        return acc;
    }, [] as IHoursOption[]);
};
import {dayNamesArray, type IHoursOption} from "@pg-design/calendar-module";

import {IOfficesHoursData} from "../types/IOfficesHoursData";

export const getHoursOptionsFromOfficesData = (officesHoursData?: IOfficesHoursData) => {
    if (!officesHoursData) {
        return undefined;
    }
    const validHoursKeys = Object.keys(officesHoursData).filter((key) => key.includes("open_hours"));

    return validHoursKeys.reduce((acc, key) => {
        const keySplit = key.split("_");
        const dayNumber = +keySplit[keySplit.length - 1];
        // @ts-ignore
        const range = officesHoursData[key];
        if (range) {
            acc.push({
                dayName: dayNamesArray[dayNumber <= 6 ? dayNumber : 0],
                range
            });
        }

        return acc;
    }, [] as IHoursOption[]);
};
